import { createOperatorBookingSettingsService } from "api-client";

const path =
  (import.meta.env.VITE_API_BASE_URL as string | undefined)?.trim() || "";

export const operatorBookingSettingsService = createOperatorBookingSettingsService(path);

/** Matches bookings page until session provides operator id (AV-163). */
export const OPERATOR_BOOKING_SETTINGS_OPERATOR_ID = 1;
